var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNailPolish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9882 17.5C16.9882 19.9853 17.487 22 12 22C6.51299 22 7.01181 19.9853 7.01181 17.5C7.01181 15.0147 9.2451 13 12 13C14.7549 13 16.9882 15.0147 16.9882 17.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9336 2C10.4102 2 9.97579 2.40545 9.9385 2.92875L9.28833 12.0526C10.1252 11.6958 11.0482 11.5 12 11.5C12.9518 11.5 13.8748 11.6958 14.7116 12.0526L14.0615 2.92875C14.0242 2.40545 13.5898 2 13.0664 2H10.9336Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNailPolish);
export default __webpack_public_path__ + "static/media/nail-polish.3281febff67e6867485c77f6365c836f.svg";
export { ForwardRef as ReactComponent };